const formatDate = (beDate: string) => {
    const d = new Date(beDate);
    return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
};

export default formatDate;
